import "./privacy_policy.css";
import React from "react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const redirectToBack = () => {
    navigate(-1);
  };

  return (
    <section id="policy" className="section">
      <div className="container policy_container">
        <div className="terms__page_wrapper">
          <div className="terms__page">
            <h2 className="terms__page_title">Privacy Policy</h2>
            <div className="terms__page_text">
              <div className="container">
                <p>
                  At Vassabi Limited, AI Dente, we value your privacy and are
                  committed to protecting your personal information. This
                  Privacy Policy outlines how we collect, use, and share your
                  information when you subscribe to our service. By subscribing
                  to our service, you consent to the practices described in this
                  policy. Please read this policy carefully to understand how we
                  handle your information.
                </p>
                <h3>1. Information We Collect</h3>
                <p>
                  When you use our service, we may collect the following types
                  of information:
                </p>
                <p>
                  • a. Personal Information: Subscription Data: When you
                  subscribe to our service, we collect your mobile phone number
                  and any other necessary billing details. These details help us
                  process your subscription and maintain accurate records. Age
                  Verification: To comply with age restrictions, we may collect
                  information to ensure that you are over 18 years of age or
                  have permission from a parent or guardian if you are under 18.
                </p>
                <p>
                  • b. Technical Information: Device and Network Information:
                  When you access our portal, we may collect details about your
                  device, such as your IP address, browser type, and mobile
                  network information. Usage Data: We track how you use our
                  service, including browsing activities, page interactions, and
                  the content you access.
                </p>

                <h3>2. How We Use Your Information</h3>
                <p>
                  We use the collected information for the following purposes:
                </p>
                <p>
                  • Service Provision and Maintenance: To process your
                  subscription, including automatic renewal unless you choose to
                  unsubscribe. To send you and renewal alerts via SMS.{" "}
                </p>
                <p>
                  • Communication: To send you important service-related
                  updates, such as subscription, renewals. To respond to any
                  feedback or inquiries you submit via support@vassabi.com.
                </p>
                <p>
                  • Improvement of Services: To analyze how users interact with
                  our service so that we can improve the platform, including the
                  user interface, content offerings, and overall performance.
                </p>
                <p>
                  • Compliance with Legal Obligations: We may use your personal
                  information to comply with applicable laws, regulations, and
                  legal processes.
                </p>

                <h3>3. Cookies and Tracking Technologies</h3>
                <p>
                  • We may use cookies and similar tracking technologies to
                  enhance your experience on our portal. Cookies are small data
                  files stored on your device that allow us to:
                </p>
                <p>
                  • Remember your preferences, such as language settings (the
                  portal is in English). Track usage patterns and improve
                  service performance. You can manage your cookie preferences
                  through your browser settings, but disabling cookies may
                  affect your ability to use some features of the service.
                </p>

                <h3>4. Data Sharing and Disclosure</h3>
                <p>
                  • We do not sell or rent your personal information to third
                  parties. However, we may share your information in the
                  following scenarios:
                </p>
                <p>
                  • Legal Compliance: We may disclose your information if
                  required to do so by law or in response to valid legal
                  requests from government authorities.
                </p>
                <p>
                  • Data Security We implement appropriate technical and
                  organizational measures toprotect your personal information
                  from unauthorized access, disclosure, alteration,
                  ordestruction. However, no method of data transmission or
                  storage is completely secure, and we cannot guarantee the
                  absolute security of your information.
                </p>

                <h3>5. Retention of Your Information</h3>
                <p>
                  • We will retain your personal information for as long as
                  necessary to fulfill the purposes outlined in this policy.
                  This may include retaining your data to comply with legal
                  obligations, resolve disputes, and enforce our agreements.
                </p>

                <h3>6. Children’s Privacy</h3>
                <p>
                  • Our service is intended for users who are at least 18 years
                  old or who have obtained parental consent. We do not knowingly
                  collect personal information from children under 18. If we
                  become aware that we have inadvertently collected personal
                  data from a child without consent, we will take steps to
                  delete that information.
                </p>

                <h3>7. Data Usage and Charges</h3>
                <p>
                  • Please note that standard data charges may apply when
                  browsing or downloading content from our portal if you are not
                  using a data bundle. It is your responsibility to manage your
                  data usage according to your mobile plan.
                </p>

                <h3>8. International Data Transfers</h3>
                <p>
                  • We operate globally, and your information may be transferred
                  to and processed in countries outside your own. We ensure that
                  any data transfers comply with applicable privacy laws and
                  that your data is protected by adequate safeguards.
                </p>

                <h3>9. Changes to This Privacy Policy</h3>
                <p>
                  • We may update this Privacy Policy from time to time to
                  reflect changes in our practices or relevant legal
                  requirements. We will notify you of any significant changes by
                  posting a notice on our portal or sending an SMS alert. Your
                  continued use of the service after such changes constitutes
                  acceptance of the revised policy.
                </p>

                <h3>10. Contact Us</h3>
                <p>
                  • If you have any questions, concerns, or feedback regarding
                  this Privacy Policy or our data handling practices, please
                  contact us at support@vassabi.com.
                </p>
                <p>
                  • By using our service, you acknowledge that you have read and
                  understood this PrivacyPolicy and agree to the collection,
                  use, and disclosure of your personal information asdescribed
                  herein.
                </p>

                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
